import React from 'react'
import {
   Element
} from 'react-scroll'
import ScrollTopOnMount from 'utils/ScrollTopOnMount'
import ReactHtmlParser from 'react-html-parser';
import Config from 'Config'
import axios from 'axios'
import Skills from 'components/Skills/'
import Partner from 'components/Partner/'
import Contact from 'components/Contact/'

class Home extends React.Component {

   constructor() {
      super()
      this.state = {
         data: {},
      }
   }

   componentDidMount() {
      this.getData();
   }

   getData() {

      axios.get(Config().endpoints.api + "/home")
         .then(response => {
            if (response.data) {
               this.setState({
                  data: response.data[0]
               });
            }
         })
         .catch((error) => {})
   }

   createMarkup() {
      return {
         __html: 'First &middot; Second'
      };
   }

   render() {
      return (<div>
         <ScrollTopOnMount/>
         <Element name="home" className="elememt">
            <div className="content-container colored">
               <div className="content-section">
                  <div className="ui divider hidden"></div>
                  <h1 className="large">{this.state.data.title}</h1>
                  <div className="headline-subtext large">{this.state.data.subtitle}</div><br></br>
                  <div>{ ReactHtmlParser(this.state.data.content) }</div>
               </div>
            </div>
         </Element>
         <Element name="skills" className="elememt">
            <Skills />
         </Element>
         <Element name="contact" className="elememt">
            <Contact />
         </Element>

      </div>);
   }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/index.js